import React from 'react'

import Page from 'shared/timber/v1/Layout/Page'
import styles from './styles.module.scss'

interface Props {
  noPadding?: boolean
  children?: React.ReactNode
}

/**
 * Basic layout for the public app pages. This layout does not
 * have any navigation and will center the content both horizontally
 * and vertically
 */
const GlobalLayout: React.FC<Props> = ({ children, noPadding }) => (
  <Page noPadding>
    <div
      className={[
        styles.Layout,
        noPadding ? styles['Layout--no-padding'] : '',
      ].join(' ')}
    >
      {children}
    </div>
  </Page>
)

export default GlobalLayout
